var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.hericaClientPostErrors },
        on: {
          "update:errors": function($event) {
            _vm.hericaClientPostErrors = $event
          }
        }
      }),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Username",
                  "error-messages": _vm.hericaClientPostErrors.name
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function() {
                      return [
                        _c(
                          "base-tooltip",
                          {
                            attrs: {
                              color: _vm.$objectEmpty(_vm.infoErrors)
                                ? "primary"
                                : "error",
                              text: "",
                              "x-small": "",
                              dark: "",
                              tooltip: "Info",
                              bottom: ""
                            },
                            on: {
                              click: function($event) {
                                _vm.openInfo = true
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-account-details")])],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Email",
                  type: "email",
                  "error-messages": _vm.hericaClientPostErrors.email
                },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Password", type: "password" },
                model: {
                  value: _vm.password,
                  callback: function($$v) {
                    _vm.password = $$v
                  },
                  expression: "password"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-switch", {
                attrs: { color: "primary", label: "Active" },
                model: {
                  value: _vm.active,
                  callback: function($$v) {
                    _vm.active = $$v
                  },
                  expression: "active"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-btn",
        {
          attrs: {
            color: "primary",
            dense: "",
            small: "",
            dark: "",
            loading: _vm.hericaClientPosting
          },
          on: { click: _vm.sendRequest }
        },
        [_c("span", [_vm._v("Save")])]
      ),
      _c(
        "v-dialog",
        {
          attrs: { eager: "", width: "800" },
          model: {
            value: _vm.openInfo,
            callback: function($$v) {
              _vm.openInfo = $$v
            },
            expression: "openInfo"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: "primary",
                    dense: "",
                    elevation: "0",
                    dark: ""
                  }
                },
                [_c("span", [_vm._v("Info")])]
              ),
              _c(
                "v-container",
                [
                  _c("herica-client-info-form", {
                    attrs: { errors: _vm.infoErrors },
                    model: {
                      value: _vm.info,
                      callback: function($$v) {
                        _vm.info = $$v
                      },
                      expression: "info"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }